import React, { useEffect, useState } from "react";
import "./pod-upload-model.scss";
import { Row, Col, Space, Divider, Select, Button, Spin } from "antd";
import crossicon from "../../../assets/images/available-reverse-model-crossicon.svg";
import calender from "../../../assets/images/pod-upload-model-calender.svg";
import docAttachment from "../../../assets/images/document-attachment-pod.svg";
import verticleLine from "../../../assets/images/pod-upload-model-line.svg";
import timeQuarter from "../../../assets/images/pod-upload-model-time-quarter-pass.svg";
import truck from "../../../assets/images/pod-upload-model-truck.svg";
import rightArrow from "../../../assets/images/arrow-right-pod.svg";
import leftarrowC from '../../../assets/images/order-details-leftarrow.svg'
import rightarrowC from '../../../assets/images/order-details-rightarrowC.svg'
import * as homeService from "./../../../service/home/homeService"
import moment from "moment";
import NodataImg from "../../../assets/images/nodata-img.svg";
import { useNavigate, useNavigation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PodUploadModel = ({ userId, isOpen, setIsOpen }) => {
   const { t } = useTranslation();
  const navigate = useNavigate();
  const [proofOfDeliveryListLoading, setProofOfDeliveryListLoading] = useState(true);
  const [podData, setPodData] = useState([]);
  const [activeIndexMsg, setActiveIndexMsg] = useState({});
  
  useEffect(() => {
    getProofOfDeliveryList();
  }, []);

  const getProofOfDeliveryList = () => {
    let payload = {};
    setProofOfDeliveryListLoading(true);
    setPodData([]);
    homeService.getProofOfDeliveryList(payload).then(res => {
      if (res.data?.data?.length > 0) {
        setPodData(res.data?.data);
      }
      setProofOfDeliveryListLoading(false);
    }).catch(error => {
      console.error("Technical error occured during get proof of delivery list");
      setProofOfDeliveryListLoading(false);
    })

  }
  const navigationTimer = 10000;
  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveIndexMsg((prev) => {
        const newItem = { ...prev };

        podData.forEach((item) => {
          const key = String(item.orderNumber);
          const currentIndex = newItem[key] || 0;

          if (item?.alerts?.length > 0) {
            newItem[key] =
              currentIndex < item.alerts.length - 1 ? currentIndex + 1 : 0;
          }
        });

        return newItem;
      });
    }, navigationTimer);

    return () => clearInterval(intervalId);
  }, [podData]);

  const [currentUserId, setCurrentUserId] = useState(userId);

  const handleNavigation = (direction, item) => {
    const key = String(item.orderNumber);
    setActiveIndexMsg((prev) => {
      const currentIndex = prev[key] || 0;
      const totalAlerts = item.alerts.length;
      let newIndex;

      if (direction === "right") {
        newIndex = currentIndex < totalAlerts - 1 ? currentIndex + 1 : 0;
      }
      else {
        newIndex = currentIndex > 0 ? currentIndex - 1 : totalAlerts - 1;
      }

      return {
        ...prev,
        [key]: newIndex,
      };
    });
  };
  // Close the modal if the click is outside the modal area
  const handleOutsideClick = (e) => {
    if (e.target.id === "modal-background") {
      setIsOpen(false);  // Close the modal if the background is clicked
    }
  };

  return (
    <>

      {isOpen && (
        <div
          id="modal-background"
          className="modal-background"
          onClick={handleOutsideClick}
        >
          <div className="modal open">
            <div className="modal-content">
              <div className="title-row">
                <span className="title-caption-row">
                  <span>{t("HOME_POD_UPLOAD")}</span>
                  <span>{t("HOME_POD_PENDING_MSG")}</span>
                </span>
                <span className="crossicon" onClick={(e) => setIsOpen(false)}>
                  <img src={crossicon} alt="close" />
                </span>
              </div>
              {proofOfDeliveryListLoading ? <Spin /> :
               podData.length > 0 ? podData?.map((item, index) => {

                  return (
                    <Row className="pod-card-wrapper">

                      <div className="date-time-order-row">

                        <span className="order-no">{item?.orderNumber}

                        </span>
                        <span className="date-time">{item?.moveDate ? moment.utc(item?.moveDate).format("DD MMM h:mm A") : "NA"}</span>


                      </div>
                      <div className="shipperName-class">{item?.shipperName}</div>
                      <div className="middle-row-wrapper">
                        <Col >

                          <div className="from-to-address-wrapper">
                            <span ><img src={verticleLine} /></span>
                            <div className="from-to-address">
                              {/* from address span starts here  */}
                              <div className="from-address">
                                <span>{item?.fromCity}</span>
                                <span>{item?.fromCountry}</span>
                              </div>
                              {/* to address span starts here  */}
                              <div className="to-address">
                                <span>{item?.toCity}</span>
                                <span>{item?.toCountry}</span>
                              </div>
                            </div>
                          </div>
                        </Col>


                      </div>
                      <Row className="currency-row"><span className="currency-value">{item?.currency} {item?.amount}</span> <span className="total-earnings">{t("HOME_TOTAL_EARNINGS")}</span></Row>
                      <div className="truckno-eta-wrapper">
                        <Col>
                          <span className="truck-wrapper">
                            <span className="img-title"><img src={truck} /> </span>
                            <span className="truck-no-value">{item?.assetCategory}-{item?.assetSubCategory}</span>
                          </span>
                        </Col>
                        <Col>
                          <span className="eta-wrapper">
                            <span className="img-title">{item?.noOfAssets}</span>
                            <span className="eta-value">{t("HOME_TRUCKS")}</span>
                          </span>
                        </Col>
                      </div>
                      <div  className="message-wrapper-div">
               <div className="message-wrapper">
                          <span className="doc-text">
                            <img className="doc-img" src={docAttachment} alt="icon" />{item?.alerts[activeIndexMsg[item?.orderNumber] || 0]?.message}
                            {/* {item?.alerts[activeIndexMsg[item?.orderNumber] || 0]?.assetRegistrationNumber} */}
                          </span>
                          <span style={{ cursor: "pointer" }} onClick={async () => {
                            navigate(`/orders/${item?.orderNumber}/${item?.alerts[activeIndexMsg[item?.orderNumber] || 0]?.tripId}/${item?.alerts[activeIndexMsg[item?.orderNumber] || 0]?.assetRegistrationNumber}-${item?.alerts[activeIndexMsg[item?.orderNumber] || 0]?.driverName}`);
                          }}>

                            <img src={rightArrow} alt="->" />

                          </span>

                        </div>
               {   item?.alerts.length>1 &&      <Space style={{display:'flex', justifyContent:'center'}}>
                          <img src={leftarrowC} style={{cursor:'pointer'}} alt="<-" onClick={() => handleNavigation('left', item)} />
                          <img src={rightarrowC} style={{cursor:'pointer'}} alt="->" onClick={() => handleNavigation('right', item)} />

                        </Space>}
                      </div>
                    </Row>
                  )
                }
                ) :
                <Row justify={'center'} className="no-data">
                <img src={NodataImg} alt='no data' />
            </Row>
                
                }

            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PodUploadModel;
